import {
  ACCOUNT_API,
  ADMIN_ACCOUNTS_API,
  COMPLETE_TKV2_ORDERS_API,
  IMAGE_ANALYSIS_API,
  MARKET_AGGREGATE_DATA_API,
  ORCHESTRATE_AUTOFILL_PROPERTY_API,
  ORDER_DEPRECIATION_SETTINGS_V2_API,
  PAIRED_SALES_SINGLE_API,
  PREFILL_ORDER_API,
  PROPERTY_IMAGE_ANALYSIS_API,
  QA_ATTEMPTS,
  TKV2_GEOCODING_API,
  TKV2_ORDERS_API,
  TKV2_ORDER_API,
  TKV2_ORDER_ATTACHMENT_API,
  TKV2_ORDER_DEPRECIATION_SETTINGS_API,
  TKV2_ORDER_PAIRED_COST_SETTINGS_API,
  TKV2_ORDER_REPLACEMENT_COST_SETTINGS_API,
  TKV2_PUBLIC_RECORD_API,
  TRAINING_ORDERS_API,
  TRAINING_ORDER_API,
} from '@aloft/toolkit-shared';

/**
 * @deprecated - We shouldn't be using this - We should simply use the generated hooks and fetchers in `toolkitComponents` directly.
 *
 * This is a registry of all the endpoints that want to generate schema parsing RQ hooks.
 * To opt in simply add the operationId to the registry and schema and the existing code gen
 * (i.e. `yarn apiCodeGen:tk`) will generate the corresponding hook in this folder.
 *
 * Note: schemas includes both input and output,
 * conventionally, schema is just used for apis that do not have input body.
 */
export const Registry = {
  getTkv2OrderSubjectAPI: {
    schema: TKV2_ORDER_ATTACHMENT_API.SUBJECT.GET.RESPONSE,
  },
  getTkv2OrderAPI: {
    schema: TKV2_ORDER_API.GET.RESPONSE,
  },
  getTkv2OrdersAPI: {
    schema: TKV2_ORDERS_API.GET.RESPONSE,
  },
  getAccount: {
    schema: ACCOUNT_API.GET.RESPONSE,
  },
  getTkv2PublicRecordAPI: {
    schema: TKV2_PUBLIC_RECORD_API.GET.RESPONSE,
  },
  postTkv2CompsAPI: {
    schemas: TKV2_ORDER_ATTACHMENT_API.COMPS.POST,
  },
  completeTkv2OrderAPI: {
    schema: COMPLETE_TKV2_ORDERS_API.PUT.RESPONSE,
  },
  updatePairedSalesStudy: {
    schemas: PAIRED_SALES_SINGLE_API.PUT,
  },
  getTkv2OrderReplacementCostSettingsAPI: {
    schema: TKV2_ORDER_REPLACEMENT_COST_SETTINGS_API.GET.RESPONSE,
  },
  putTkv2OrderReplacementCostSettingsAPI: {
    schemas: TKV2_ORDER_REPLACEMENT_COST_SETTINGS_API.PUT,
  },
  getTkv2OrderPairedCostSettingsAPI: {
    schema: TKV2_ORDER_PAIRED_COST_SETTINGS_API.GET.RESPONSE,
  },
  putTkv2OrderPairedCostSettingsAPI: {
    schemas: TKV2_ORDER_PAIRED_COST_SETTINGS_API.PUT,
  },
  getTkv2OrderDepreciationSettingsAPI: {
    schema: TKV2_ORDER_DEPRECIATION_SETTINGS_API.GET.RESPONSE,
  },
  putTkv2OrderDepreciationSettingsAPI: {
    schemas: TKV2_ORDER_DEPRECIATION_SETTINGS_API.PUT,
  },
  getOrderDepreciationSettingsV2API: {
    schema: ORDER_DEPRECIATION_SETTINGS_V2_API.GET.RESPONSE,
  },
  putOrderDepreciationSettingsV2API: {
    schemas: ORDER_DEPRECIATION_SETTINGS_V2_API.PUT,
  },
  createTkv2OrderAPI: {
    schemas: TKV2_ORDER_API.POST,
  },
  createTrainingOrderAPI: {
    schemas: TRAINING_ORDER_API.POST,
  },
  createAllTrainingOrdersAPI: {
    schemas: TRAINING_ORDERS_API.PUT,
  },
  getCompRecommendation: {
    schema: TKV2_ORDER_ATTACHMENT_API.COMP_RECOMMENDATION.GET.RESPONSE,
  },
  getSubjectData: {
    schema: TKV2_ORDER_ATTACHMENT_API.SUBJECT_DATA.GET.RESPONSE,
  },
  getAllCompData: {
    schema: TKV2_ORDER_ATTACHMENT_API.COMP_DATA.GET.RESPONSE,
  },
  createCompData: {
    schemas: TKV2_ORDER_ATTACHMENT_API.COMP_DATA.POST,
  },
  postImageAnalysis: {
    schemas: IMAGE_ANALYSIS_API.POST,
  },
  getPropertyImageAnalysis: {
    schema: PROPERTY_IMAGE_ANALYSIS_API.GET.RESPONSE,
  },
  getMarketAdjustments: {
    schema: TKV2_ORDER_ATTACHMENT_API.MARKET_ADJUSTMENTS.GET.RESPONSE,
  },
  putMarketAdjustments: {
    schemas: TKV2_ORDER_ATTACHMENT_API.MARKET_ADJUSTMENTS.PUT,
  },
  getCompImages: {
    schema: TKV2_ORDER_ATTACHMENT_API.COMP_IMAGES.GET.RESPONSE,
  },
  getQaAttempt: {
    schema: QA_ATTEMPTS.GET.RESPONSE,
  },
  postQaAttempt: {
    schemas: QA_ATTEMPTS.POST,
  },
  getCoordinatesForAddressesAPI: {
    schema: TKV2_GEOCODING_API.COORDINATES_FOR_ADDRESSES.GET.RESPONSE,
  },
  prefillOrder: {
    schema: PREFILL_ORDER_API.POST.RESPONSE,
  },
  orchestrateAutofillProperty: {
    schema: ORCHESTRATE_AUTOFILL_PROPERTY_API.GET.RESPONSE,
  },
  listAccountsAPI: {
    schema: ADMIN_ACCOUNTS_API.GET.RESPONSE,
  },
  getMarketAggregateDataAPI: {
    schema: MARKET_AGGREGATE_DATA_API.GET.RESPONSE,
  },
};
